import { GoogleOAuthProvider } from "@react-oauth/google";
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";
import reportWebVitals from "./reportWebVitals";

import { initReactI18next } from "react-i18next";
import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// Importa le traduzioni per le varie lingue
import translationEN from "./locales/en.json";
import translationIT from "./locales/it.json";

i18n.use(initReactI18next)
    .use(LanguageDetector)
    .init({
        resources: {
            en: {
                translation: translationEN,
            },
            it: {
                translation: translationIT,
            },
        },
        fallbackLng: "en",
        lng: localStorage.getItem("language") || "en",
        //debug: true,
        interpolation: {
            escapeValue: false,
        },
        react: {
            wait: true,
        },
    });

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    //<React.StrictMode>
    <GoogleOAuthProvider clientId="31125434408-pb1o344tvogmrkom807c1qv0t5ho6m6d.apps.googleusercontent.com">
        <App />
    </GoogleOAuthProvider>
    //</React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
